// @router
import { RouteConfig } from "vue-router";
const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/components/base/routerParrent.vue");
const index = () => import("../views/index.vue");
const detail = () => import("../views/detail.vue");

export const jobsProfileRoutes: RouteConfig[] = [
  {
    path: "/jobs-profile",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "search",
        name: "jobs_profile",
        component: index,
        meta: {
          label: "جستجوی شغل",
          requiresAuth: true,
          redesigned: true,
          hasMaxWidth: false,
          deprecated: true,
        },
      },
      {
        path: "job/:code",
        name: "jobs-profile-job",
        component: detail,
        meta: {
          label: "شغل",
          requiresAuth: true,
          redesigned: true,
          hasMaxWidth: false,
          deprecated: true,
        },
      },
    ],
  },
];
